import React from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import appConfig from "../../config";

const octopartLogo =
  appConfig.filePath + "react-app-images/Powered-by-Octopart.svg";

const ListItems = ({ results, sellers }) => {
  const { t } = useTranslation();
  return (
    <div className="j-tab-wrap">
      <div
        id="tab-ja-modal"
        className="j-tab-content is-active"
        style={{
          visibility: "visible",
          overflow: "hidden",
          maxHeight: "none",
          opacity: "1",
          pointerEvents: "all",
          transition: "opacity 0.4s ease 0s, visibility 0.4s ease 0s"
        }}
      >
        <div className="c-tab__content">
          <div className="u-table u-font--s">
            <table>
              <thead>
                <tr>
                  <th width="25%">{t("Model")}</th>
                  <th width="25%">{t("Distributor")}</th>
                  <th width="25%">{t("Inventory number")}</th>
                  <th width="25%"></th>
                </tr>
              </thead>
              <tbody>
                {sellers.map(({ company, offers, octopartUrl, mpn }) => {
                  const showBuyOnline =
                    +get(offers, "0.inventoryLevel", 0) > 0;
                  return (
                    <tr key={`${mpn}-${company.id}`}>
                      <td>{mpn}</td>
                      <td>{company.name}</td>
                      <td>{get(offers, "0.inventoryLevel", 0)}</td>
                      <td>
                        {showBuyOnline && (
                          <div className="c-button__list">
                            <a
                              href={get(offers, "0.clickUrl", octopartUrl)}
                              className="c-button--ec j-modal-open"
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {t("Buy Online")}
                            </a>
                          </div>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="ocotpart-logo">
            <img
              src={octopartLogo}
              width="210"
              height="29"
              alt="Powered-by-Nexar"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListItems;
